import { categoryKeys } from '@cvg/community-localizations'

export const ENTRIES_FETCH_LIMIT = 50
export const FILTER_DATE_MIN = '2024-01-01'

export const DROPDOWN_CATEGORIES = new Map(Object.entries(categoryKeys))

export const LEGACY_CATEGORY_MAPPINGS = Object.freeze({
  'Celebrations & Events': 'Celebrations',
  'Health & Wellbeing': 'Health & Nutrition',
  'Family Life': 'Moms & Babies'
})

export const DROPDOWN_COUNTRIES = new Map([
  ['BF', 'Burkina Faso (BF)'],
  ['DO', 'Dominican Republic (DO)'],
  ['GH', 'Ghana (GH)'],
  ['KE', 'Kenya (KE)'],
  ['KH', 'Cambodia (KH)'],
  ['MW', 'Malawi (MW)'],
  ['PE', 'Peru (PE)'],
  ['RW', 'Rwanda (RW)'],
  ['TH', 'Thailand (TH)'],
  ['TZ', 'Tanzania (TZ)'],
  ['UG', 'Uganda (UG)'],
  ['US', 'United States (US)'],
  ['ZM', 'Zambia (ZM)']
])

export const SORT_OPTIONS = Object.freeze({
  'Newest': '-sys.createdAt',
  'Oldest': 'sys.createdAt',
  'Country': 'fields.country',
  'Category': 'fields.category'
})

export const TAG_TYPES = Object.freeze({
  category: {
    label: 'Category',
    sortOrder: 3
  },
  country: {
    label: 'Country',
    sortOrder: 1
  },
  fcpId: {
    label: 'FCP',
    sortOrder: 2
  }
})
